import React from "react"
import formatPrice from '../../utils/formatPrice';
import {useShoppingCart} from 'use-shopping-cart';
import '../../styles/cart-entry-controls.scss'

export default function ProductMeta({price}) {
    const { 
        cartDetails,
        addItem,
        decrementItem,
        incrementItem,
        removeItem,
        handleCartClick
    } = useShoppingCart()

    const cartEntryControls = function () {
        const cartEntry = cartDetails[price.id];

        return (
            <article className='cart-entry-controls'>
                <p>This item is in your cart</p>
                <button
                    className='text'
                    onClick={() => removeItem(cartEntry.sku)}
                    aria-label={`Remove all ${cartEntry.name} from your cart`}
                >
                    Remove
                </button>
                <div className='quantity'>
                    <button
                        className='icon'
                        onClick={() => decrementItem(cartEntry.sku)}
                        aria-label={`Remove one ${cartEntry.name} from your cart`}
                    >
                        -
                    </button>
                    <p>Quantity: {cartEntry.quantity}</p>
                    <button
                        className='icon'
                        onClick={() => incrementItem(cartEntry.sku)}
                        aria-label={`Add one ${cartEntry.name} to your cart`}
                    >
                        +
                    </button>
                </div>
                <button onClick={handleCartClick}><span>View Cart</span></button>
            </article>
        )
    }

    return (
        <div>
            <p>{formatPrice(price.unit_amount,price.currency)}</p>
            {
                cartDetails[price.id] ?
                    cartEntryControls()
                :
                    <button
                        onClick={() => addItem({
                            sku: price.id,
                            name: price.product.name,
                            price: price.unit_amount,
                            currency: price.currency
                        })}
                    ><span>Add To Cart</span></button>
            }
        </div>
    )
}